import { validateAFM, validatePhoneNumber } from "utils";

export const formFields1 = [
  {
    label: 'Ονομα',
    id: 'firstName',
    type: 'text',
    name: 'firstName',
    size: 'large',
    placeholder: 'Εισάγετε Όνομα',
    containerClassName: 'register-custom-field-grey custom-padding disabled',
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Επώνυμο',
    id: 'lastName',
    type: 'text',
    name: 'lastName',
    size: 'large',
    placeholder: 'Εισάγετε Επώνυμο',
    containerClassName: 'register-custom-field-grey disabled',
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'ΑΦΜ Eπιχείρησης',
    id: 'companyVat',
    type: 'text',
    name: 'companyVat',
    size: 'large',
    placeholder: 'Εισάγετε ΑΦΜ',
    containerClassName: 'register-custom-field-grey disabled',
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    () => ({
        validator(_, value) {
          return value ? validateAFM(value.toString()) : Promise.resolve();
        },}),   
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Επωνυμία Επιχείρησης',
    id: 'companyName',
    type: 'text',
    name: 'companyName',
    size: 'large',
    placeholder: 'Εισάγετε Επωνυμία Επιχείρησης',
    containerClassName: 'register-custom-field-grey disabled',
    span: 24,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },    
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Μέγεθος Επιχείρησης',
    id: 'companySize',
    type: 'businessSize',
    name: 'companySize',
    span: 24,
    bold: true,
    defaultValue: '',
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    disabled: true,
    view: true,
  },
    {
    label: 'Ημερομηνία Ίδρυσης',
    type: 'date',
    id: 'foundingDate',
    name: 'foundingDate',
    allowClear: true,
    size: 'large',
    placeholder: 'Εισάγετε Ημερομηνία Ίδρυσης',
    className: 'w-100 like-text',
    containerClassName: 'register-custom-field-grey disabled',
    span: 8,
    asterisk: true,
    disabled: true,
    iconPlacement: 'left',
    // disabledDate: d => !d || d.isAfter('2010-12-31'), //|| d.isBefore('2012-01-01') || 
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
  },
  {
    label: 'Τηλέφωνο',
    id: 'phoneNumber',
    type: 'text',
    name: 'phoneNumber',
    size: 'large',
    placeholder: 'Εισάγετε Τηλέφωνο',
    containerClassName: 'register-custom-field-grey disabled',
    maxLength: 10,
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
            validator(_, value) {
              return validatePhoneNumber(value, false);
            },
          }),
    ],
    asterisk: true,
    disabled: true,
  },
    {
    label: 'Email',
    id: 'email',
    type: 'text',
    name: 'email',
    size: 'large',
    placeholder: 'Εισάγετε Email',
    containerClassName: 'register-custom-field-grey emaillll disabled',
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { type: 'email', message: 'Αυτό που εισάγετε δεν είναι έγκυρη διεύθυνση e-mail'}
    ],
    asterisk: true,
    disabled: true,
  },
];

export const formFields2 = [
  //     {
  //   label: 'Θέμα',
  //   id: 'subject',
  //   type: 'text',
  //   name: 'subject',
  //   size: 'large',
  //   placeholder: 'Εισάγετε Θέμα',
  //   containerClassName: 'register-custom-field',
  //   span: 24,
  //   rules: [
  //     { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
  //   //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
  //   ],
  //   asterisk: true,
  //   disabled: true,
  // },
  {
    label: 'Κείμενο',
    id: 'text',
    type: 'textarea',
    name: 'text',
    size: 'large',
    placeholder: 'Εισάγετε Κείμενο',
    containerClassName: 'register-custom-field disabled',
    rows: 11,
    simple: true,
    span: 24,
    maxLength: 1000,
    rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        { max: 999 , message: 'Το πεδίο μπορεί να έχει το πολύ 1000 χαρακτήρες' },
    ],
    asterisk: true,
    disabled: true,
}, 
];